/* eslint-disable @typescript-eslint/unbound-method */
import { Injectable } from '@angular/core'
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class MatchFormCreateService {

  private form: UntypedFormGroup

  constructor(private fb: FormBuilder) { }

  public createForm(): UntypedFormGroup {
    this.form = this.fb.group({
      selectedUser: ['', [Validators.required]],
    })

    return this.form
  }
}
